import { render, staticRenderFns } from "./newReportLabelInput.vue?vue&type=template&id=16474bdc&scoped=true"
import script from "./newReportLabelInput.vue?vue&type=script&lang=js"
export * from "./newReportLabelInput.vue?vue&type=script&lang=js"
import style0 from "./newReportLabelInput.vue?vue&type=style&index=0&id=16474bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16474bdc",
  null
  
)

export default component.exports